import React from 'react';

import ResourcesPageLayout from '../components/ResourcesPageLayout';
import * as styles from './ResourceFilesListSectionPage.module.scss';
import FileRow from '../components/FileRow';
import { useUpdateUrlFromFilters, usePagination } from '../utils/hooks';
import SEO from '../components/SEO';

interface ResourceFile {
  title: string;
  file?: {
    asset?: {
      size: number;
      url: string;
    };
  };
}

interface ResourceFilesListSectionPageProps {
  pageContext: {
    title: string;
    slug: {
      current: string;
    };
    resourceFiles: Array<ResourceFile>;
  };
}

const ResourceFilesListSectionPage = ({
  pageContext: resourceFilesSection,
}: ResourceFilesListSectionPageProps): React.ReactElement => {
  const { resourceFiles } = resourceFilesSection;

  const {
    currentPage,
    currentPageItems: currentPageArticles,
    getPageUrlPart,
    renderPagination,
  } = usePagination(resourceFiles, 20);

  // Update url on filters state change
  useUpdateUrlFromFilters(() => {
    return [getPageUrlPart()];
  }, [currentPage]);

  return (
    <ResourcesPageLayout currentSlug={resourceFilesSection.slug.current} withPageContentBox>
      <SEO
        title={resourceFilesSection.title}
        urlPath={'/resources/' + resourceFilesSection.slug.current}
      />
      <div className={styles.content}>
        <h2>{resourceFilesSection.title}</h2>
        {/* <p className={styles.intro}>{resourceFilesSection.intro}</p> */}
        {currentPageArticles.map(
          (resourceFile, i) =>
            !!(resourceFile.file && resourceFile.file.asset) && (
              <FileRow
                key={i}
                title={resourceFile.title}
                size={resourceFile.file.asset.size}
                url={resourceFile.file.asset.url}
              ></FileRow>
            ),
        )}
      </div>

      {renderPagination()}
    </ResourcesPageLayout>
  );
};

export default ResourceFilesListSectionPage;
